import { Modal } from "antd";

function GeneralErrorMsg({ title, content }) {
	return Modal.error({
		title: title,
		content: content,
		centered: true
	});
}

export default GeneralErrorMsg;
